import { render, staticRenderFns } from "./Warning.vue?vue&type=template&id=0787abf7&scoped=true&"
import script from "./Warning.vue?vue&type=script&lang=ts&"
export * from "./Warning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0787abf7",
  null
  
)

export default component.exports